// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-screen .preloading-area .preloading-message .dot{display:inline-block;width:5px}.vue-progress-path .progress{stroke:#fff!important;stroke-width:11px!important}.vue-progress-path .background{stroke:#ab1822!important;stroke-width:11px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
